import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  location: null,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    removeLocation: (state) => {
      state.location = null;
    },
    removeImage: (state, action) => {
      const indexesToRemove = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];

      state.location.images = state.location.images.filter(
        (_, idx) => !indexesToRemove.includes(idx)
      );
    },
  },
});

export const { setLocation, removeLocation, removeImage } =
  locationSlice.actions;
export default locationSlice.reducer;
